// extracted by mini-css-extract-plugin
export default {"overlay":"StyledPopover_overlay__DgDPt"};